import { useEffect } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { SubmitButton } from 'framework/ui/ui-builder';
import { useFormContext, EnumDropdown } from 'framework/form';
import rejectFormValidationSchema from './rejectFormValidationSchema';
import { REJECTION_REASONS_BY_STAGE } from '../../../constants';
import { Box } from '@mui/material';

interface RejectStageFormProps {
  handleCancelClick: () => void;
  sourceStage: string;
}

const RejectStageForm = ({ handleCancelClick, sourceStage }: RejectStageFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();
  const options = Object.entries(REJECTION_REASONS_BY_STAGE).find(([key, _]) => key === sourceStage);
  const reasons = options ? options[1] : null;

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(rejectFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <EnumDropdown options={reasons as Dictionary<string>} source="reason" />
      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default RejectStageForm;
